<template>
  <Calendario />
</template>

<script>
import Calendario from '@/components/drp/configDrpAutomatizado/CalendarioSeparacao.vue';

export default {
  components: { Calendario }
}
</script>
